import ContentService from '@/services/ContentService';

export default {
  data() {
    return {
      path: this.$route.meta.path || this.$route.path,
      content: {
        block: [],
        list: [],
      },
    };
  },
  async created() {
    const content = await this.getContent();

    if (content.block || content.list) {
      this.content = content;
    }

    this.setHeadMetaData();
  },
  methods: {
    async getContent() {
      let res = {};

      try {
        res = await ContentService.get(this.path);

        return res.data;
      } catch (e) {
        return {
          block: [],
          list: [],
        };
      }
    },
    setHeadMetaData() {
      const titleEl = document.head.querySelector('title');
      if (titleEl && this.content.title) titleEl.textContent = this.content.title;

      const descEl = document.head.querySelector('meta[name="description"]');
      if (descEl && this.content.description != null) {
        descEl.setAttribute('content', this.content.description);
      }

      const keywordsEl = document.head.querySelector('meta[name="keywords"]');
      if (keywordsEl && this.content.keywords != null) {
        keywordsEl.setAttribute('content', this.content.keywords);
      }
    },
    setPath(path) {
      this.path = path;
    },
  },
};
